import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import { Selector } from '../../../common/components';
import { vimoRoles } from '../../../common/constants';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    filter: {
        marginRight: theme.spacing(2),

        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    flex: {
        flex: '1 1 auto',
    },
    addLinkIcon: {
        color: theme.palette.secondary.main,
    },
    action: {
        [theme.breakpoints.down('xs')]: {
            height: 30,
            minHeight: 30,
            width: 30,
        },
    },
});

class UserListFilter extends React.Component {
    handleChange = name => (event) => {
        this.props.onUpdate({
            ...this.props.filter,
            [name]: event.target.value,
        });
    }

    render() {
        const {
            classes, translate, className, filter,
        } = this.props;

        const roles = vimoRoles.map(item => ({ id: item, name: translate(`user.appRoles_${item}`) }));

        return (
            <div className={classnames(classes.root, className)}>
                <Selector
                    id="rolefilter"
                    value={filter.role}
                    items={roles}
                    addEmptyItemInList
                    label={translate('user.roles')}
                    onChange={this.handleChange('role')}
                    className={classes.filter}
                />

                <div className={classes.flex} />
            </div>
        );
    }
}

UserListFilter.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    className: PropTypes.string,
};

UserListFilter.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    profileData: state.auth.profileData,
    clientConfig: state.auth.clientConfig,
});


export default connect(mapStateToProps)(withStyles(styles)(UserListFilter));
